const EditMode = {
  NONE: "NONE",
  FRAME: "FRAME",
  FRAME_WITH_LENSES: "FRAME_WITH_LENSES",
};

export default EditMode;
